import type { Store } from "vuex";
import type { IRootState } from "@/store";
import { AuthActions } from "@/store/modules/auth";
import { resetDashboardMain } from "@/composables/useDashboardMain";

let sessionExitInProgress = false;

/** Clears only the active session. Remembered account cards and locale stay on this device. */
export async function leaveCurrentAccount(
  store: Store<IRootState>
): Promise<void> {
  if (sessionExitInProgress) {
    return;
  }

  sessionExitInProgress = true;
  resetDashboardMain();
  try {
    sessionStorage.clear();
  } catch {
    // A restricted browser storage mode must not prevent session termination.
  }

  try {
    await store.dispatch(AuthActions.LOGOUT);
  } finally {
    window.location.replace("/login");
  }
}
